import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FieldType = /*#__PURE__*/function (FieldType) {
  FieldType[FieldType["FIELD_TYPE_INVALID"] = 0] = "FIELD_TYPE_INVALID";
  FieldType[FieldType["FIELD_TYPE_STRING"] = 1] = "FIELD_TYPE_STRING";
  FieldType[FieldType["FIELD_TYPE_INTEGER"] = 2] = "FIELD_TYPE_INTEGER";
  FieldType[FieldType["FIELD_TYPE_DATE"] = 3] = "FIELD_TYPE_DATE";
  FieldType[FieldType["FIELD_TYPE_DROPDOWN"] = 4] = "FIELD_TYPE_DROPDOWN";
  FieldType[FieldType["FIELD_TYPE_CURRENCY"] = 5] = "FIELD_TYPE_CURRENCY";
  FieldType[FieldType["FIELD_TYPE_BOOLEAN"] = 6] = "FIELD_TYPE_BOOLEAN";
  FieldType[FieldType["FIELD_TYPE_RADIO"] = 7] = "FIELD_TYPE_RADIO";
  FieldType[FieldType["FIELD_TYPE_RICH_TEXT_ELEMENT"] = 8] = "FIELD_TYPE_RICH_TEXT_ELEMENT";
  FieldType[FieldType["FIELD_TYPE_EMAIL"] = 9] = "FIELD_TYPE_EMAIL";
  FieldType[FieldType["FIELD_TYPE_PHONE"] = 10] = "FIELD_TYPE_PHONE";
  FieldType[FieldType["FIELD_TYPE_BUSINESS_SEARCH"] = 11] = "FIELD_TYPE_BUSINESS_SEARCH";
  return FieldType;
}(FieldType || {});
var JsonSchemaLibrary = /*#__PURE__*/function (JsonSchemaLibrary) {
  JsonSchemaLibrary[JsonSchemaLibrary["JSON_SCHEMA_LIBRARY_UNDEFINED"] = 0] = "JSON_SCHEMA_LIBRARY_UNDEFINED";
  JsonSchemaLibrary[JsonSchemaLibrary["JSON_SCHEMA_LIBRARY_JSONFORM"] = 1] = "JSON_SCHEMA_LIBRARY_JSONFORM";
  return JsonSchemaLibrary;
}(JsonSchemaLibrary || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateFormRequest {
  static fromProto(proto) {
    let m = new CreateFormRequest();
    m = Object.assign(m, proto);
    if (proto.formConfig) {
      m.formConfig = FormConfig.fromProto(proto.formConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formConfig !== 'undefined' && this.formConfig !== null) {
      toReturn['formConfig'] = 'toApiJson' in this.formConfig ? this.formConfig.toApiJson() : this.formConfig;
    }
    return toReturn;
  }
}
class CreateFormResponse {
  static fromProto(proto) {
    let m = new CreateFormResponse();
    m = Object.assign(m, proto);
    if (proto.errors) {
      m.errors = proto.errors.map(ValidationError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class CreateFormSubmissionRequest {
  static fromProto(proto) {
    let m = new CreateFormSubmissionRequest();
    m = Object.assign(m, proto);
    if (proto.submission) {
      m.submission = UserFormSubmission.fromProto(proto.submission);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.submission !== 'undefined' && this.submission !== null) {
      toReturn['submission'] = 'toApiJson' in this.submission ? this.submission.toApiJson() : this.submission;
    }
    if (typeof this.recaptchaToken !== 'undefined') {
      toReturn['recaptchaToken'] = this.recaptchaToken;
    }
    return toReturn;
  }
}
class CreateFormSubmissionResponse {
  static fromProto(proto) {
    let m = new CreateFormSubmissionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.redirectUrl !== 'undefined') {
      toReturn['redirectUrl'] = this.redirectUrl;
    }
    return toReturn;
  }
}
class DeleteFormRequest {
  static fromProto(proto) {
    let m = new DeleteFormRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class FormConfigField {
  static fromProto(proto) {
    let m = new FormConfigField();
    m = Object.assign(m, proto);
    if (proto.schema) {
      m.schema = FormConfigFieldSchema.fromProto(proto.schema);
    }
    if (proto.defaultValue) {
      m.defaultValue = FieldValue.fromProto(proto.defaultValue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.schema !== 'undefined' && this.schema !== null) {
      toReturn['schema'] = 'toApiJson' in this.schema ? this.schema.toApiJson() : this.schema;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.hidden !== 'undefined') {
      toReturn['hidden'] = this.hidden;
    }
    if (typeof this.defaultValue !== 'undefined' && this.defaultValue !== null) {
      toReturn['defaultValue'] = 'toApiJson' in this.defaultValue ? this.defaultValue.toApiJson() : this.defaultValue;
    }
    if (typeof this.preFillByUrlQueryParameter !== 'undefined') {
      toReturn['preFillByUrlQueryParameter'] = this.preFillByUrlQueryParameter;
    }
    if (typeof this.placeholder !== 'undefined') {
      toReturn['placeholder'] = this.placeholder;
    }
    return toReturn;
  }
}
class FieldOption {
  static fromProto(proto) {
    let m = new FieldOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    return toReturn;
  }
}
class FieldValue {
  static fromProto(proto) {
    let m = new FieldValue();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invalid !== 'undefined') {
      toReturn['invalid'] = this.invalid;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.boolean !== 'undefined') {
      toReturn['boolean'] = this.boolean;
    }
    return toReturn;
  }
}
class ListFormsRequestFilters {
  static fromProto(proto) {
    let m = new ListFormsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class FormConfig {
  static fromProto(proto) {
    let m = new FormConfig();
    m = Object.assign(m, proto);
    if (proto.styles) {
      m.styles = Styles.fromProto(proto.styles);
    }
    if (proto.fields) {
      m.fields = proto.fields.map(FormConfigField.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.styles !== 'undefined' && this.styles !== null) {
      toReturn['styles'] = 'toApiJson' in this.styles ? this.styles.toApiJson() : this.styles;
    }
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.formType !== 'undefined') {
      toReturn['formType'] = this.formType;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.mostRecent !== 'undefined') {
      toReturn['mostRecent'] = this.mostRecent;
    }
    if (typeof this.redirectUrl !== 'undefined') {
      toReturn['redirectUrl'] = this.redirectUrl;
    }
    if (typeof this.recaptchaSiteKey !== 'undefined') {
      toReturn['recaptchaSiteKey'] = this.recaptchaSiteKey;
    }
    if (typeof this.recaptchaSecretKey !== 'undefined') {
      toReturn['recaptchaSecretKey'] = this.recaptchaSecretKey;
    }
    if (typeof this.submitButtonLabel !== 'undefined') {
      toReturn['submitButtonLabel'] = this.submitButtonLabel;
    }
    return toReturn;
  }
}
class GetMultiRequestFormConfigIdentifier {
  static fromProto(proto) {
    let m = new GetMultiRequestFormConfigIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class ListFormsResponseFormRow {
  static fromProto(proto) {
    let m = new ListFormsResponseFormRow();
    m = Object.assign(m, proto);
    if (proto.form) {
      m.form = FormConfig.fromProto(proto.form);
    }
    if (proto.numberOfSubmissions) {
      m.numberOfSubmissions = parseInt(proto.numberOfSubmissions, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.form !== 'undefined' && this.form !== null) {
      toReturn['form'] = 'toApiJson' in this.form ? this.form.toApiJson() : this.form;
    }
    if (typeof this.numberOfSubmissions !== 'undefined') {
      toReturn['numberOfSubmissions'] = this.numberOfSubmissions;
    }
    return toReturn;
  }
}
class FormSubmission {
  static fromProto(proto) {
    let m = new FormSubmission();
    m = Object.assign(m, proto);
    if (proto.values) {
      m.values = proto.values.map(FormSubmissionSubmittedValue.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formSubmissionId !== 'undefined') {
      toReturn['formSubmissionId'] = this.formSubmissionId;
    }
    if (typeof this.formVersion !== 'undefined') {
      toReturn['formVersion'] = this.formVersion;
    }
    if (typeof this.values !== 'undefined' && this.values !== null) {
      toReturn['values'] = 'toApiJson' in this.values ? this.values.toApiJson() : this.values;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class GetEmbedCodeRequest {
  static fromProto(proto) {
    let m = new GetEmbedCodeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    return toReturn;
  }
}
class GetEmbedCodeResponse {
  static fromProto(proto) {
    let m = new GetEmbedCodeResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embedCode !== 'undefined') {
      toReturn['embedCode'] = this.embedCode;
    }
    return toReturn;
  }
}
class GetFormRequest {
  static fromProto(proto) {
    let m = new GetFormRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    return toReturn;
  }
}
class GetFormResponse {
  static fromProto(proto) {
    let m = new GetFormResponse();
    m = Object.assign(m, proto);
    if (proto.formConfig) {
      m.formConfig = FormConfig.fromProto(proto.formConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formConfig !== 'undefined' && this.formConfig !== null) {
      toReturn['formConfig'] = 'toApiJson' in this.formConfig ? this.formConfig.toApiJson() : this.formConfig;
    }
    return toReturn;
  }
}
class GetMultiFormSubmissionRequest {
  static fromProto(proto) {
    let m = new GetMultiFormSubmissionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formSubmissionIds !== 'undefined') {
      toReturn['formSubmissionIds'] = this.formSubmissionIds;
    }
    return toReturn;
  }
}
class GetMultiFormSubmissionResponse {
  static fromProto(proto) {
    let m = new GetMultiFormSubmissionResponse();
    m = Object.assign(m, proto);
    if (proto.submissions) {
      m.submissions = proto.submissions.map(FormSubmission.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.submissions !== 'undefined' && this.submissions !== null) {
      toReturn['submissions'] = 'toApiJson' in this.submissions ? this.submissions.toApiJson() : this.submissions;
    }
    return toReturn;
  }
}
class GetMultiFormVersionsListRequest {
  static fromProto(proto) {
    let m = new GetMultiFormVersionsListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formIds !== 'undefined') {
      toReturn['formIds'] = this.formIds;
    }
    return toReturn;
  }
}
class GetMultiFormVersionsListResponse {
  static fromProto(proto) {
    let m = new GetMultiFormVersionsListResponse();
    m = Object.assign(m, proto);
    if (proto.versions) {
      m.versions = proto.versions.map(GetMultiFormVersionsListResponseVersions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.versions !== 'undefined' && this.versions !== null) {
      toReturn['versions'] = 'toApiJson' in this.versions ? this.versions.toApiJson() : this.versions;
    }
    return toReturn;
  }
}
class GetMultiRequest {
  static fromProto(proto) {
    let m = new GetMultiRequest();
    m = Object.assign(m, proto);
    if (proto.formConfigIdentifiers) {
      m.formConfigIdentifiers = proto.formConfigIdentifiers.map(GetMultiRequestFormConfigIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formConfigIdentifiers !== 'undefined' && this.formConfigIdentifiers !== null) {
      toReturn['formConfigIdentifiers'] = 'toApiJson' in this.formConfigIdentifiers ? this.formConfigIdentifiers.toApiJson() : this.formConfigIdentifiers;
    }
    return toReturn;
  }
}
class GetMultiResponse {
  static fromProto(proto) {
    let m = new GetMultiResponse();
    m = Object.assign(m, proto);
    if (proto.formConfigs) {
      m.formConfigs = proto.formConfigs.map(FormConfig.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formConfigs !== 'undefined' && this.formConfigs !== null) {
      toReturn['formConfigs'] = 'toApiJson' in this.formConfigs ? this.formConfigs.toApiJson() : this.formConfigs;
    }
    return toReturn;
  }
}
class ListFormSubmissionRequest {
  static fromProto(proto) {
    let m = new ListFormSubmissionRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListFormSubmissionResponse {
  static fromProto(proto) {
    let m = new ListFormSubmissionResponse();
    m = Object.assign(m, proto);
    if (proto.submissions) {
      m.submissions = proto.submissions.map(FormSubmission.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.submissions !== 'undefined' && this.submissions !== null) {
      toReturn['submissions'] = 'toApiJson' in this.submissions ? this.submissions.toApiJson() : this.submissions;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListFormsRequest {
  static fromProto(proto) {
    let m = new ListFormsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListFormsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListFormsResponse {
  static fromProto(proto) {
    let m = new ListFormsResponse();
    m = Object.assign(m, proto);
    if (proto.formRows) {
      m.formRows = proto.formRows.map(ListFormsResponseFormRow.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formRows !== 'undefined' && this.formRows !== null) {
      toReturn['formRows'] = 'toApiJson' in this.formRows ? this.formRows.toApiJson() : this.formRows;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListMappedFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListMappedFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.crmObjectType !== 'undefined') {
      toReturn['crmObjectType'] = this.crmObjectType;
    }
    if (typeof this.crmObjectSubtype !== 'undefined') {
      toReturn['crmObjectSubtype'] = this.crmObjectSubtype;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.mappedToResource !== 'undefined') {
      toReturn['mappedToResource'] = this.mappedToResource;
    }
    return toReturn;
  }
}
class ListMappedFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListMappedFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(MappedField.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class MappedField {
  static fromProto(proto) {
    let m = new MappedField();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(FieldType, proto.type);
    }
    if (proto.options) {
      m.options = proto.options.map(FieldOption.fromProto);
    }
    if (proto.systemDefined) {
      m.systemDefined = SystemDefined.fromProto(proto.systemDefined);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    if (typeof this.mappedTo !== 'undefined') {
      toReturn['mappedTo'] = this.mappedTo;
    }
    if (typeof this.systemDefined !== 'undefined' && this.systemDefined !== null) {
      toReturn['systemDefined'] = 'toApiJson' in this.systemDefined ? this.systemDefined.toApiJson() : this.systemDefined;
    }
    if (typeof this.readonly !== 'undefined') {
      toReturn['readonly'] = this.readonly;
    }
    return toReturn;
  }
}
class RenderFormResponsePreFillByUrlQueryParameter {
  static fromProto(proto) {
    let m = new RenderFormResponsePreFillByUrlQueryParameter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.queryParam !== 'undefined') {
      toReturn['queryParam'] = this.queryParam;
    }
    return toReturn;
  }
}
class PreviewFormRequest {
  static fromProto(proto) {
    let m = new PreviewFormRequest();
    m = Object.assign(m, proto);
    if (proto.formConfig) {
      m.formConfig = FormConfig.fromProto(proto.formConfig);
    }
    if (proto.library) {
      m.library = enumStringToValue(JsonSchemaLibrary, proto.library);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formConfig !== 'undefined' && this.formConfig !== null) {
      toReturn['formConfig'] = 'toApiJson' in this.formConfig ? this.formConfig.toApiJson() : this.formConfig;
    }
    if (typeof this.library !== 'undefined') {
      toReturn['library'] = this.library;
    }
    return toReturn;
  }
}
class PreviewFormResponse {
  static fromProto(proto) {
    let m = new PreviewFormResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonUiSchema !== 'undefined') {
      toReturn['jsonUiSchema'] = this.jsonUiSchema;
    }
    return toReturn;
  }
}
class RenderFormRequest {
  static fromProto(proto) {
    let m = new RenderFormRequest();
    m = Object.assign(m, proto);
    if (proto.library) {
      m.library = enumStringToValue(JsonSchemaLibrary, proto.library);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.library !== 'undefined') {
      toReturn['library'] = this.library;
    }
    return toReturn;
  }
}
class RenderFormResponse {
  static fromProto(proto) {
    let m = new RenderFormResponse();
    m = Object.assign(m, proto);
    if (proto.styles) {
      m.styles = Styles.fromProto(proto.styles);
    }
    if (proto.fieldQueryParams) {
      m.fieldQueryParams = proto.fieldQueryParams.map(RenderFormResponsePreFillByUrlQueryParameter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonUiSchema !== 'undefined') {
      toReturn['jsonUiSchema'] = this.jsonUiSchema;
    }
    if (typeof this.styles !== 'undefined' && this.styles !== null) {
      toReturn['styles'] = 'toApiJson' in this.styles ? this.styles.toApiJson() : this.styles;
    }
    if (typeof this.fieldQueryParams !== 'undefined' && this.fieldQueryParams !== null) {
      toReturn['fieldQueryParams'] = 'toApiJson' in this.fieldQueryParams ? this.fieldQueryParams.toApiJson() : this.fieldQueryParams;
    }
    if (typeof this.recaptchaSiteKey !== 'undefined') {
      toReturn['recaptchaSiteKey'] = this.recaptchaSiteKey;
    }
    return toReturn;
  }
}
class FormConfigFieldSchema {
  static fromProto(proto) {
    let m = new FormConfigFieldSchema();
    m = Object.assign(m, proto);
    if (proto.unmappedField) {
      m.unmappedField = UnmappedField.fromProto(proto.unmappedField);
    }
    if (proto.mappedField) {
      m.mappedField = MappedField.fromProto(proto.mappedField);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.unmappedField !== 'undefined' && this.unmappedField !== null) {
      toReturn['unmappedField'] = 'toApiJson' in this.unmappedField ? this.unmappedField.toApiJson() : this.unmappedField;
    }
    if (typeof this.mappedField !== 'undefined' && this.mappedField !== null) {
      toReturn['mappedField'] = 'toApiJson' in this.mappedField ? this.mappedField.toApiJson() : this.mappedField;
    }
    return toReturn;
  }
}
class Styles {
  static fromProto(proto) {
    let m = new Styles();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.width !== 'undefined') {
      toReturn['width'] = this.width;
    }
    if (typeof this.backgroundColor !== 'undefined') {
      toReturn['backgroundColor'] = this.backgroundColor;
    }
    if (typeof this.borderColor !== 'undefined') {
      toReturn['borderColor'] = this.borderColor;
    }
    if (typeof this.borderRadius !== 'undefined') {
      toReturn['borderRadius'] = this.borderRadius;
    }
    if (typeof this.borderWidth !== 'undefined') {
      toReturn['borderWidth'] = this.borderWidth;
    }
    if (typeof this.borderStyle !== 'undefined') {
      toReturn['borderStyle'] = this.borderStyle;
    }
    if (typeof this.padding !== 'undefined') {
      toReturn['padding'] = this.padding;
    }
    if (typeof this.primaryFontColor !== 'undefined') {
      toReturn['primaryFontColor'] = this.primaryFontColor;
    }
    if (typeof this.primaryColor !== 'undefined') {
      toReturn['primaryColor'] = this.primaryColor;
    }
    if (typeof this.onPrimaryColor !== 'undefined') {
      toReturn['onPrimaryColor'] = this.onPrimaryColor;
    }
    return toReturn;
  }
}
class FormSubmissionSubmittedValue {
  static fromProto(proto) {
    let m = new FormSubmissionSubmittedValue();
    m = Object.assign(m, proto);
    if (proto.fieldValue) {
      m.fieldValue = FieldValue.fromProto(proto.fieldValue);
    }
    if (proto.fieldType) {
      m.fieldType = enumStringToValue(FieldType, proto.fieldType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.fieldValue !== 'undefined' && this.fieldValue !== null) {
      toReturn['fieldValue'] = 'toApiJson' in this.fieldValue ? this.fieldValue.toApiJson() : this.fieldValue;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.mappedToResource !== 'undefined') {
      toReturn['mappedToResource'] = this.mappedToResource;
    }
    return toReturn;
  }
}
class SystemDefined {
  static fromProto(proto) {
    let m = new SystemDefined();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.includedByDefault !== 'undefined') {
      toReturn['includedByDefault'] = this.includedByDefault;
    }
    if (typeof this.hidden !== 'undefined') {
      toReturn['hidden'] = this.hidden;
    }
    return toReturn;
  }
}
class UnmappedField {
  static fromProto(proto) {
    let m = new UnmappedField();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(FieldType, proto.type);
    }
    if (proto.options) {
      m.options = proto.options.map(FieldOption.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    return toReturn;
  }
}
class UpdateFormRequest {
  static fromProto(proto) {
    let m = new UpdateFormRequest();
    m = Object.assign(m, proto);
    if (proto.formConfig) {
      m.formConfig = FormConfig.fromProto(proto.formConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formConfig !== 'undefined' && this.formConfig !== null) {
      toReturn['formConfig'] = 'toApiJson' in this.formConfig ? this.formConfig.toApiJson() : this.formConfig;
    }
    return toReturn;
  }
}
class UpdateFormResponse {
  static fromProto(proto) {
    let m = new UpdateFormResponse();
    m = Object.assign(m, proto);
    if (proto.errors) {
      m.errors = proto.errors.map(ValidationError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class UserFormSubmission {
  static fromProto(proto) {
    let m = new UserFormSubmission();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class ValidationError {
  static fromProto(proto) {
    let m = new ValidationError();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ruleId !== 'undefined') {
      toReturn['ruleId'] = this.ruleId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class GetMultiFormVersionsListResponseVersions {
  static fromProto(proto) {
    let m = new GetMultiFormVersionsListResponseVersions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.versions !== 'undefined') {
      toReturn['versions'] = this.versions;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'forms-api.vendasta-local.com',
  'test': '',
  'demo': 'forms-demo.apigateway.co',
  'prod': 'forms-prod.apigateway.co',
  'production': 'forms-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let FormSubmissionApiService = /*#__PURE__*/(() => {
  class FormSubmissionApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createFormSubmission(r) {
      const request = r.toApiJson ? r : new CreateFormSubmissionRequest(r);
      return this.http.post(this._host + "/forms.v1.FormSubmissionService/CreateFormSubmission", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateFormSubmissionResponse.fromProto(resp)));
    }
    listFormSubmission(r) {
      const request = r.toApiJson ? r : new ListFormSubmissionRequest(r);
      return this.http.post(this._host + "/forms.v1.FormSubmissionService/ListFormSubmission", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFormSubmissionResponse.fromProto(resp)));
    }
    getMultiFormSubmission(r) {
      const request = r.toApiJson ? r : new GetMultiFormSubmissionRequest(r);
      return this.http.post(this._host + "/forms.v1.FormSubmissionService/GetMultiFormSubmission", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiFormSubmissionResponse.fromProto(resp)));
    }
  }
  FormSubmissionApiService.ɵfac = function FormSubmissionApiService_Factory(t) {
    return new (t || FormSubmissionApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  FormSubmissionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FormSubmissionApiService,
    factory: FormSubmissionApiService.ɵfac,
    providedIn: 'root'
  });
  return FormSubmissionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let FormsApiService = /*#__PURE__*/(() => {
  class FormsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getEmbedCode(r) {
      const request = r.toApiJson ? r : new GetEmbedCodeRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/GetEmbedCode", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmbedCodeResponse.fromProto(resp)));
    }
    getForm(r) {
      const request = r.toApiJson ? r : new GetFormRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/GetForm", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFormResponse.fromProto(resp)));
    }
    getMultiFormVersionsList(r) {
      const request = r.toApiJson ? r : new GetMultiFormVersionsListRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/GetMultiFormVersionsList", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiFormVersionsListResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiResponse.fromProto(resp)));
    }
    createForm(r) {
      const request = r.toApiJson ? r : new CreateFormRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/CreateForm", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateFormResponse.fromProto(resp)));
    }
    updateForm(r) {
      const request = r.toApiJson ? r : new UpdateFormRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/UpdateForm", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateFormResponse.fromProto(resp)));
    }
    listForms(r) {
      const request = r.toApiJson ? r : new ListFormsRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/ListForms", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListFormsResponse.fromProto(resp)));
    }
    renderForm(r) {
      const request = r.toApiJson ? r : new RenderFormRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/RenderForm", request.toApiJson(), this.apiOptions()).pipe(map(resp => RenderFormResponse.fromProto(resp)));
    }
    deleteForm(r) {
      const request = r.toApiJson ? r : new DeleteFormRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/DeleteForm", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    previewForm(r) {
      const request = r.toApiJson ? r : new PreviewFormRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/PreviewForm", request.toApiJson(), this.apiOptions()).pipe(map(resp => PreviewFormResponse.fromProto(resp)));
    }
    listMappedFieldSchema(r) {
      const request = r.toApiJson ? r : new ListMappedFieldSchemaRequest(r);
      return this.http.post(this._host + "/forms.v1.Forms/ListMappedFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMappedFieldSchemaResponse.fromProto(resp)));
    }
  }
  FormsApiService.ɵfac = function FormsApiService_Factory(t) {
    return new (t || FormsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  FormsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FormsApiService,
    factory: FormsApiService.ɵfac,
    providedIn: 'root'
  });
  return FormsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let FormSubmissionsExportService = /*#__PURE__*/(() => {
  class FormSubmissionsExportService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    exportCSV(formId) {
      const url = `${this._host}/form-submissions/export-csv`;
      return this.http.post(url, {
        form_id: formId
      }, {
        observe: 'response',
        responseType: 'blob',
        withCredentials: true
      }).pipe(map(response => {
        const contentDisposition = response.headers.get('content-disposition') || 'form-submissions.csv';
        const filename = contentDisposition.replace('attachment; filename=', '').replace(/"/g, '');
        return {
          filename: filename,
          blob: response.body || new Blob([], {
            type: 'text/csv'
          })
        };
      }));
    }
  }
  FormSubmissionsExportService.ɵfac = function FormSubmissionsExportService_Factory(t) {
    return new (t || FormSubmissionsExportService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  FormSubmissionsExportService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FormSubmissionsExportService,
    factory: FormSubmissionsExportService.ɵfac,
    providedIn: 'root'
  });
  return FormSubmissionsExportService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// MANUALLY CREATED FILE
// Don't delete this by mistake when you update the SDK with mscli!

/**
 * Generated bundle index. Do not edit.
 */

export { CreateFormRequest, CreateFormResponse, CreateFormSubmissionRequest, CreateFormSubmissionResponse, DeleteFormRequest, FieldOption, FieldType, FieldValue, FormConfig, FormConfigField, FormConfigFieldSchema, FormSubmission, FormSubmissionApiService, FormSubmissionSubmittedValue, FormSubmissionsExportService, FormsApiService, GetEmbedCodeRequest, GetEmbedCodeResponse, GetFormRequest, GetFormResponse, GetMultiFormSubmissionRequest, GetMultiFormSubmissionResponse, GetMultiFormVersionsListRequest, GetMultiFormVersionsListResponse, GetMultiFormVersionsListResponseVersions, GetMultiRequest, GetMultiRequestFormConfigIdentifier, GetMultiResponse, HostService, JsonSchemaLibrary, ListFormSubmissionRequest, ListFormSubmissionResponse, ListFormsRequest, ListFormsRequestFilters, ListFormsResponse, ListFormsResponseFormRow, ListMappedFieldSchemaRequest, ListMappedFieldSchemaResponse, MappedField, PagedRequestOptions, PagedResponseMetadata, PreviewFormRequest, PreviewFormResponse, RenderFormRequest, RenderFormResponse, RenderFormResponsePreFillByUrlQueryParameter, Styles, SystemDefined, UnmappedField, UpdateFormRequest, UpdateFormResponse, UserFormSubmission, ValidationError };
